import React from "react";
import loadable from "@loadable/component";
import LoadingFrame from "../../../LoadingFrame";

export default loadable(() => import("./handsign"), { fallback: <LoadingFrame /> });
